import { useState, useEffect, useRef } from 'react';
import { API_URL } from '../config';

const SHOWN_AT_KEY = 'trm_rating_shown_at';
const DONE_KEY = 'trm_rating_done';
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;
export const DELAY_MS = 42000;

function shouldShow() {
  const shownAt = localStorage.getItem(SHOWN_AT_KEY);
  const done = localStorage.getItem(DONE_KEY);

  // Mai mostrato → mostra
  if (!shownAt) return true;

  // Non ancora votato e passato più di 30 giorni → riprova
  if (done !== 'true' && Date.now() - new Date(shownAt).getTime() > THIRTY_DAYS_MS) {
    return true;
  }

  return false;
}

export default function useRatingPrompt(apiResponse, tier) {
  const [isOpen, setIsOpen] = useState(false);
  const triggeredForRef = useRef(null);

  useEffect(() => {
    // Solo risposte valide (non null, non errore)
    if (!apiResponse || apiResponse.error || !apiResponse.response) return;
    // Già avviato il timer per questa risposta
    if (triggeredForRef.current === apiResponse) return;

    triggeredForRef.current = apiResponse;

    const timer = setTimeout(() => {
      if (shouldShow()) {
        localStorage.setItem(SHOWN_AT_KEY, new Date().toISOString());
        setIsOpen(true);
      }
    }, DELAY_MS);

    return () => clearTimeout(timer);
  }, [apiResponse]);

  const dismiss = () => {
    setIsOpen(false);
  };

  const submit = async (rating, comment) => {
    try {
      await fetch(`${API_URL}/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating, comment, tier: tier || 'unknown', dismissed: false }),
      });
    } catch { /* silenzioso */ }
    localStorage.setItem(DONE_KEY, 'true');
  };

  const openManually = () => {
    localStorage.setItem(SHOWN_AT_KEY, new Date().toISOString());
    setIsOpen(true);
  };

  return { isOpen, dismiss, submit, openManually };
}
